<!-- Revised on 2025/05/13 by mnavarro -->
<template>
  <div id="sidenav-collapse-main" class="w-auto h-auto collapse navbar-collapse max-height-vh-500 h-500">
    <ul class="navbar-nav">
      <li class="nav-item">
        <!-- Main dashboard -->
        <sidenav-item :to="{ name: 'Dashboard' }" :text="$t('key_sidenavmenu_main_dashboard')"
          :class="getRoute(1) === 'Dashboard' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-chart-pie" :class="getRoute(1) === 'Dashboard' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>
      
        <!-- Products -->
        <sidenav-item :to="{ name: 'Products list' }" :text="$t('key_sidenavmenu_products')"
          :class="getRoute(2) === 'Products' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-cubes" :class="getRoute(2) === 'Products' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>

        <!-- Orders -->
        <sidenav-item :to="{ name: 'Orders list' }" :text="$t('key_sidenavmenu_orders')"
          :class="getRoute(2) === 'Orders' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-shopping-bag" :class="getRoute(2) === 'Orders' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>
        <!-- Shipments -->
        <sidenav-item :to="{ name: 'Shipments list' }" :text="$t('key_sidenavmenu_shipments')"
          :class="getRoute(2) === 'Shipments' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-truck" :class="getRoute(2) === 'Shipments' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>
        <!-- Ordersback -->
        <sidenav-item :to="{ name: 'Ordersback list' }" :text="$t('key_sidenavmenu_ordersback')"
          :class="getRoute(2) === 'Ordersback' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-cubes" :class="getRoute(2) === 'Ordersback' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>
        <!-- Purchases -->
        <sidenav-item :to="{ name: 'Purchases list' }" :text="$t('key_sidenavmenu_purchases')"
          :class="getRoute(2) === 'Purchases' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-shopping-cart" :class="getRoute(2) === 'Purchases' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>
        <!-- Proof of delivery -->
        <sidenav-item :to="{ name: 'PoDs list' }" :text="$t('key_sidenavmenu_pods')"
          :class="getRoute(2) === 'PoDs' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-clipboard-list" :class="getRoute(2) === 'PoDs' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>

        <!-- Warehouse -->
        <sidenav-item :to="{ name: 'Warehouse summary list' }" :text="$t('key_sidenavmenu_warehouse_summary')"
          :class="getRoute(2) === 'WarehouseSummary' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-warehouse" :class="getRoute(2) === 'WarehouseSummary' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>
        <!-- Stock -->
        <sidenav-item :to="{ name: 'Stock product list' }" :text="$t('key_sidenavmenu_product_stock')"
          :class="getRoute(2) === 'ProductStock' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-dolly" :class="getRoute(2) === 'ProductStock' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>

        <!-- Imported files -->
        <sidenav-item :to="{ name: 'Imported files list' }" :text="$t('key_sidenavmenu_imported_files')"
          :class="getRoute(2) === 'ImportedFiles' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-upload" :class="getRoute(2) === 'ImportedFiles' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>

        <!-- Users -->
        <sidenav-item :to="{ name: 'Users list' }" :text="$t('key_sidenavmenu_users')"
          :class="getRoute(2) === 'Users' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-users" :class="getRoute(2) === 'Users' ? 'icon-white' : 'icon-primary'" aria-hidden="true"></i>
          </template>
        </sidenav-item>
      </li>

      <!-- Panel de customer service de Picko -->
      <li v-if="$PickoVersion.isV1() && ($Permission.isInternalUser() || $Permission.isInternalAdmin())" class="mt-3 nav-item">
        <h6 v-if="isPinned" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2">
          {{ $t('key_sidenavlist_panel_pickocustomerservice') }}
        </h6>
        <hr v-else class="mt-0 horizontal dark" />
      </li>
      
      <li class="nav-item" v-if="$PickoVersion.isV1()">
        <!-- Customers -->
        <sidenav-collapse v-if="$Permission.isCustomerService() || $Permission.isInternalAdmin()" collapse-ref="customerServiceBrandsDataGroup" :nav-text="$t('key_sidenavlist_group_customerservice')"
          :class="getRoute(1) === 'CustomerService' && getRoute(2) === 'Customers' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-id-card" :class="getRoute(1) === 'CustomerService' && getRoute(2) === 'Customers' ? 'icon-white' : 'icon-primary'"></i>
          </template>
          <template #list>
            <ul class="navbar-nav" :class="isPinned ? 'ms-3 ps-2' : ''">
              <!-- Brands new -->
              <!-- <sidenav-item :to="{ name: 'Customer service brands list' }" :text="$t('key_sidenavmenu_brands')"
                :class="getRoute(3) === 'Brands' ? 'active router-link-exact-active nav-link' : ''">
                <template #icon>
                  <i class="fa-solid fa-trademark" :class="getRoute(3) === 'Brands' ? 'icon-white' : 'icon-primary'"></i>
                </template>
              </sidenav-item> -->
            </ul>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Panel de administración de Picko -->
      <li v-if="$PickoVersion.isV1() && $Permission.isInternalAdmin()" class="mt-3 nav-item">
        <h6 v-if="isPinned" class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2">
          {{ $t('key_sidenavlist_panel_pickoadministration') }}
        </h6>
        <hr v-else class="mt-0 horizontal dark" />
      </li>

      <li class="nav-item" v-if="$PickoVersion.isV1()">
        <!-- Integrations -->
        <sidenav-collapse v-if="$Permission.isInternalAdmin()" collapse-ref="administrationIntegrationsDataGroup" :nav-text="$t('key_sidenavlist_group_integrationservice')"
          :class="getRoute(1) === 'Integrations' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-link" :class="getRoute(1) === 'Integrations' ? 'icon-white' : 'icon-primary'"></i>
          </template>
          <template #list>
            <ul class="navbar-nav" :class="isPinned ? 'ms-3 ps-2' : ''">
              <!-- Alier SGA -->
              <sidenav-collapse-item refer="AlierSGA" :text="$t('key_sidenavlist_group_aliersga_integration')"
                :class="getRoute(2) === 'AlierSGA' ? 'active' : ''">
                <template #icon>
                  <i class="fa-solid fa-warehouse" :class="getRoute(2) === 'AlierSGA' ? 'icon-white' : 'icon-primary'"></i>
                </template>
                <template #nav-child-item>
                  <ul class="navbar-nav" :class="isPinned ? 'ms-4 ps-2' : ''">
                    <sidenav-item :to="{ name: 'Alier SGA Order outbox queue list' }" :text="$t('key_sidenavmenu_order_outbox_queue')"
                      :class="getRoute(3) === 'OrderOutboxQueueList' ? 'active router-link-exact-active nav-link' : ''">
                      <template #icon>
                        <i class="fa-solid fa-paper-plane" :class="getRoute(3) === 'OrderOutboxQueueList' ? 'icon-white' : 'icon-primary'"></i>
                      </template>
                    </sidenav-item>
                    <sidenav-item :to="{ name: 'Alier SGA Orderback outbox queue list' }" :text="$t('key_sidenavmenu_orderback_outbox_queue')"
                      :class="getRoute(3) === 'OrderbackOutboxQueueList' ? 'active router-link-exact-active nav-link' : ''">
                      <template #icon>
                        <i class="fa-solid fa-paper-plane" :class="getRoute(3) === 'OrderbackOutboxQueueList' ? 'icon-white' : 'icon-primary'"></i>
                      </template>
                    </sidenav-item>
                    <sidenav-item :to="{ name: 'Alier SGA Product outbox queue list' }" :text="$t('key_sidenavmenu_product_outbox_queue')"
                      :class="getRoute(3) === 'ProductOutboxQueueList' ? 'active router-link-exact-active nav-link' : ''">
                      <template #icon>
                        <i class="fa-solid fa-paper-plane" :class="getRoute(3) === 'ProductOutboxQueueList' ? 'icon-white' : 'icon-primary'"></i>
                      </template>
                    </sidenav-item>
                    <sidenav-item :to="{ name: 'Alier SGA Purchase outbox queue list' }" :text="$t('key_sidenavmenu_purchase_outbox_queue')"
                      :class="getRoute(3) === 'PurchaseOutboxQueueList' ? 'active router-link-exact-active nav-link' : ''">
                      <template #icon>
                        <i class="fa-solid fa-paper-plane" :class="getRoute(3) === 'PurchaseOutboxQueueList' ? 'icon-white' : 'icon-primary'"></i>
                      </template>
                    </sidenav-item>
                  </ul>
                </template>
              </sidenav-collapse-item>
              <sidenav-item :to="{ name: 'Old queues list' }" :text="$t('key_sidenavmenu_old_queues')"
                :class="getRoute(2) === 'OldQueues' ? 'active router-link-exact-active nav-link' : ''">
                <template #icon>
                  <i class="fa-solid fa-inbox" :class="getRoute(2) === 'OldQueues' ? 'icon-white' : 'icon-primary'"></i>
                </template>
              </sidenav-item>
            </ul>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <!-- Administration -->
        <sidenav-collapse v-if="$Permission.isInternalAdmin()" collapse-ref="administrationDataGroup" :nav-text="$t('key_sidenavlist_group_administration')"
          :class="getRoute(1) === 'Administration' ? 'active' : ''">
          <template #icon>
            <i class="fa-solid fa-gear" :class="getRoute(1) === 'Administration' ? 'icon-white' : 'icon-primary'"></i>
          </template>
          <template #list>
            <ul class="navbar-nav" :class="isPinned ? 'ms-3 ps-2' : ''">
              <!-- Packages -->
              <sidenav-item :to="{ name: 'Packages list' }" :text="$t('key_sidenavmenu_packages')"
                :class="getRoute(2) === 'Packages' ? 'active router-link-exact-active nav-link' : ''">
                <template #icon>
                  <i class="fa-solid fa-boxes-stacked" :class="getRoute(2) === 'Packages' ? 'icon-white' : 'icon-primary'"></i>
                </template>
              </sidenav-item>
              <!-- Delete documents -->
              <sidenav-item :to="{ name: 'Delete documents' }" :text="$t('key_sidenavmenu_delete_documents')"
                :class="getRoute(2) === 'DeleteDocuments' ? 'active router-link-exact-active nav-link' : ''">
                <template #icon>
                  <i class="fa-solid fa-ban" :class="getRoute(2) === 'DeleteDocuments' ? 'icon-white' : 'icon-primary'"></i>
                </template>
              </sidenav-item>
              <!-- Open cancelled documents -->
              <sidenav-item :to="{ name: 'Open cancelled documents' }" :text="$t('key_sidenavmenu_open_cancelled_documents')"
                :class="getRoute(2) === 'OpenCancelledDocuments' ? 'active router-link-exact-active nav-link' : ''">
                <template #icon>
                  <i class="fa-solid fa-arrow-rotate-left" :class="getRoute(2) === 'OpenCancelledDocuments' ? 'icon-white' : 'icon-primary'"></i>
                </template>
              </sidenav-item>
              <!-- Brands old -->
              <sidenav-item
                  v-if="$PickoVersion.isV1()"
                  :to="{ name: 'Brands list' }"
                  :text="$t('key_sidenavmenu_brands')"
                  :class="getRoute(2) === 'Brands' ? 'active router-link-exact-active nav-link' : ''"
              >
                <template #icon>
                  <i class="fa-solid fa-trademark" :class="getRoute(2) === 'Brands' ? 'icon-white' : 'icon-primary'"></i>
                </template>
              </sidenav-item>
            </ul>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>

<script>

  import { mapState } from "vuex";
  import SidenavCollapse from "./SidenavCollapse.vue";
  import SidenavCollapseItem from "./SidenavCollapseItem.vue";
  import SidenavItem from "./SidenavItem.vue";

  export default {
    name: "SidenavList",
    components: {
      SidenavCollapse,
      SidenavCollapseItem,
      SidenavItem,
    },
    props: {
      cardBg: {
        type: String,
        default: "",
      }
    },
    computed: {
      ...mapState([
        "absolute",
        "color",
        "hideConfigButton",
        "isAbsolute",
        "isNavFixed",
        "isPinned",
        "isTransparent",
        "navbarFixed",
        "navbarMinimize",
        "showConfig",
        "showFooter",
        "showNavbar",
        "showSidenav"
      ])
    },
    methods: {
      getRoute(position) {
        const routeArr = this.$route.path.split("/");
        return routeArr[position];
      },



      
      getGeneralManagementAccess() {
        return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM') || this.hasRole('ACCMAN'));
      },
      getManagementAccess() {
        return (this.hasRole('SADMIN') || this.hasRole('ADMIN') || this.hasRole('KAM'));
      },
      getAdministratorAccess() {
        return (this.hasRole('SADMIN') || this.hasRole('ADMIN'));
      },
      getUserAccess()
      {
        return false;
      },
      /* hasRole(permission) {
        return this.myAccount && this.myAccount.roles && this.myAccount.roles.includes(permission);
      },
      isAccountManager() {
        return this.myAccount && this.myAccount.accountManagers && this.myAccount.roles.includes(this.myAccount.userId);
      } */
    }
  };

</script>
